import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';
import { closeOngoingTrip } from '../../services/TripsService';
import { CloseOngoingTripRequest, TripDetails } from '../../types/Trips';

type Result = UseMutationResult<TripDetails, Error, CloseOngoingTripRequest>;

function useCloseOngoingTrip(
  successCb?: () => void,
  failureCb?: (error: string) => void,
): Result {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['close-ongoing-trip'],
    mutationFn: closeOngoingTrip,
    onSuccess: () => {
      successCb?.();
    },
    onError: (error: Error) => {
      failureCb?.(error.message);
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ['long-ongoing-trips'] });
      queryClient.invalidateQueries({ queryKey: ['trips'] });
      queryClient.invalidateQueries({ queryKey: ['trips-lazy'] });
      queryClient.invalidateQueries({ queryKey: ['trips-lazy-latest'] });
      queryClient.invalidateQueries({ queryKey: ['active-trips'] });
      queryClient.invalidateQueries({ queryKey: ['active-trip'] });
      queryClient.invalidateQueries({ queryKey: ['active-trips-lazy'] });
      queryClient.invalidateQueries({ queryKey: ['active-trips-lazy-latest'] });
      queryClient.invalidateQueries({ queryKey: ['trip'] });
      queryClient.invalidateQueries({ queryKey: ['merged-trip'] });
    },
  });
}

export default useCloseOngoingTrip;
